class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) location.reload(FacetFiltersForm.updateURLHash(searchParams));
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    FacetFiltersForm.applyPriceFilterToProducts();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static applySortByPrice() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');

    // Only apply if sorting by price
    if (sortBy !== 'price-ascending' && sortBy !== 'price-descending') return;

    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const productCards = Array.from(document.querySelectorAll('#product-grid > .grid__item'));

    // Separate products and promotions, keeping track of promotion positions
    const products = [];
    const promotionPositions = new Map(); // position -> card

    productCards.forEach((card, index) => {
      const isPromotionCard = card.querySelector('.card-promotion, .card-promotion-large__grid, .card-promotion__grid, .card-promotion_image, .card-promotion__content');
      if (isPromotionCard) {
        promotionPositions.set(index, card);
      } else {
        const priceElement = card.querySelector('.price__regular .price-item--regular');
        let price = 999999; // Default high price for products without price
        if (priceElement) {
          const priceText = priceElement.textContent.trim();
          price = parseFloat(priceText.replace('€', '').replace(',', '.').trim());
        }
        products.push({ card, price });
      }
    });

    // Sort products by price
    products.sort((a, b) => {
      if (sortBy === 'price-ascending') {
        return a.price - b.price;
      } else {
        return b.price - a.price;
      }
    });

    // Rebuild the grid: insert products and promotions in correct positions
    // Clear the grid first
    productGrid.innerHTML = '';

    let productIndex = 0;
    for (let i = 0; i < productCards.length; i++) {
      if (promotionPositions.has(i)) {
        // Insert promotion at its original position
        productGrid.appendChild(promotionPositions.get(i));
      } else {
        // Insert next sorted product
        if (productIndex < products.length) {
          productGrid.appendChild(products[productIndex].card);
          productIndex++;
        }
      }
    }
  }

  static applyPriceFilterToProducts() {
    const urlParams = new URLSearchParams(window.location.search);
    const minPrice = parseFloat(urlParams.get('filter.v.price.gte')) || 0;
    const maxPrice = parseFloat(urlParams.get('filter.v.price.lte'));

    // Only apply if there's a max price filter
    if (!maxPrice && maxPrice !== 0) return;

    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const productCards = document.querySelectorAll('#product-grid > .grid__item');
    let visibleCount = 0;
    let totalProductCards = 0;

    productCards.forEach(card => {
      // Skip promotion cards - check if card contains promotion elements
      const isPromotionCard = card.querySelector('.card-promotion, .card-promotion-large__grid, .card-promotion__grid, .card-promotion_image, .card-promotion__content');
      if (isPromotionCard) {
        return;
      }

      totalProductCards++;

      const priceElement = card.querySelector('.price__regular .price-item--regular');
      if (!priceElement) {
        visibleCount++;
        return;
      }

      // Extract price from the element text (e.g., "€15,75" -> 15.75)
      const priceText = priceElement.textContent.trim();
      const price = parseFloat(priceText.replace('€', '').replace(',', '.').trim());

      // Hide product if price is outside the filter range (and not 0 for gift variants)
      if (price > 0 && (price < minPrice || price > maxPrice)) {
        card.style.display = 'none';
      } else {
        if (card.style.display === 'none') {
          card.style.display = '';
        }
        visibleCount++;
      }
    });

    // Update product count
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    // Update count to show filtered vs total
    const updateCountText = (container) => {
      if (!container) return;
      const currentHTML = container.innerHTML;
      // Match pattern like "4 od 18 proizvoda" or "18 proizvoda"
      const match = currentHTML.match(/(\d+)\s+od\s+(\d+)/);
      if (match) {
        // Already has "X od Y" format - update X
        container.innerHTML = currentHTML.replace(/\d+\s+od\s+\d+/, `${visibleCount} od ${match[2]}`);
      } else {
        // Simple count format - change to "X od Y"
        const totalMatch = currentHTML.match(/(\d+)/);
        if (totalMatch) {
          const total = totalMatch[1];
          container.innerHTML = currentHTML.replace(/\d+/, `${visibleCount} od ${total}`);
        }
      }
    };

    if (visibleCount === 0 && totalProductCards > 0) {
      // Show empty state - replace entire grid (this also removes promotion cards)
      if (productGrid && productGrid.parentElement) {
        const emptyHTML = `
          <div class="collection collection--empty" id="product-grid" data-id="${productGrid.dataset.id}">
            <div class="loading-overlay gradient"></div>
            <div class="title-wrapper center">
              <h2 class="title title--primary">
                Nije pronađen niti jedan proizvod<br>
                <a href="${window.location.pathname}" class="underlined-link link">Upotrijebi manje filtera ili ukloni sve</a>
              </h2>
            </div>
          </div>
        `;
        productGrid.outerHTML = emptyHTML;
      }

      // Update counts to show just "0" (not "0 od X")
      if (countContainer) {
        const currentHTML = countContainer.innerHTML;
        // Replace entire count pattern with just "0"
        if (currentHTML.match(/\d+\s+od\s+\d+/)) {
          countContainer.innerHTML = currentHTML.replace(/\d+\s+od\s+\d+/, `0`);
        } else {
          countContainer.innerHTML = currentHTML.replace(/\d+/, `0`);
        }
      }
      if (countContainerDesktop) {
        const currentHTML = countContainerDesktop.innerHTML;
        // Replace entire count pattern with just "0"
        if (currentHTML.match(/\d+\s+od\s+\d+/)) {
          countContainerDesktop.innerHTML = currentHTML.replace(/\d+\s+od\s+\d+/, `0`);
        } else {
          countContainerDesktop.innerHTML = currentHTML.replace(/\d+/, `0`);
        }
      }
    } else if (visibleCount < totalProductCards) {
      // Show promotion cards when some products are visible
      productCards.forEach(card => {
        const isPromotionCard = card.querySelector('.card-promotion, .card-promotion-large__grid, .card-promotion__grid, .card-promotion_image, .card-promotion__content');
        if (isPromotionCard) {
          if (card.style.display === 'none') {
            card.style.display = '';
          }
        }
      });

      // Update count when some products are hidden
      updateCountText(countContainer);
      updateCountText(countContainerDesktop);
    } else {
      // All products visible - make sure promotion cards are visible too
      productCards.forEach(card => {
        const isPromotionCard = card.querySelector('.card-promotion, .card-promotion-large__grid, .card-promotion__grid, .card-promotion_image, .card-promotion__content');
        if (isPromotionCard) {
          if (card.style.display === 'none') {
            card.style.display = '';
          }
        }
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Apply price filter on initial page load
document.addEventListener('DOMContentLoaded', function () {
  FacetFiltersForm.applyPriceFilterToProducts();
  FacetFiltersForm.applySortByPrice();
});

// Re-sort products by displayed price when sort changes
document.addEventListener('change', function (e) {
  if (e.target && (e.target.id === 'SortBy' || e.target.id === 'SortBy-mobile')) {
    const sortValue = e.target.value;
    if (sortValue === 'price-ascending' || sortValue === 'price-descending') {
      // Let the page reload with Shopify's sort, then we'll re-sort on load
      // The DOMContentLoaded above will handle it
    }
  }
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const sliderElement = this.querySelector('.js-price-range-slider')
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));

    if (sliderElement) {
      var handle = $("#custom-handle");
      var handleMax = $("#custom-handle-max");
      var handleMob = $("#custom-handle-mob");
      var handleMaxMob = $("#custom-handle-max-mob");
      $(sliderElement).slider(
        {
          create: function () {
            handle.text($(this).slider("values", 0) + ' €');
            handleMax.text($(this).slider("values", 1) + ' €');
            handleMob.text($(this).slider("values", 0) + ' €');
            handleMaxMob.text($(this).slider("values", 1) + ' €');
          },
          range: true,
          min: parseInt(sliderElement.dataset.min),
          max: parseInt(sliderElement.dataset.max),
          values: [parseInt(sliderElement.dataset.minValue), parseInt(sliderElement.dataset.maxValue)],
          slide: function (event, ui) {
            minInput.value = ui.values[0];
            maxInput.value = ui.values[1];

            minInput.dispatchEvent(new Event('change'));
            maxInput.dispatchEvent(new Event('change'));

            handle.text(ui.values[0] + ' €');
            handleMax.text(ui.values[1] + ' €');
            handleMob.text(ui.values[0] + ' €');
            handleMaxMob.text(ui.values[1] + ' €');

            event.target.closest('form').dispatchEvent(new Event('input'));
          }
        }
      );
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);


$(function () {

  $('.js_burger').on('click', function () {
    $('.js-mobile-facets').addClass('burger-is-active');
  });

  $('.js-facet-close').on('click', function () {
    $('.js-mobile-facets').removeClass('burger-is-active');
  });

  // Prevent accordion from closing when clicking on form elements
  $(document).on('click', '.facets__item, .facet-checkbox-input, .facet-checkbox-label, .facets__list, .facets__price', function (e) {
    e.stopPropagation();
  });

  // Prevent accordion from closing when interacting with price range
  $(document).on('click', '.js-price-range-slider, .ui-slider-handle, .field__input', function (e) {
    e.stopPropagation();
  });

  // Prevent hover effects on content area from affecting summary
  $(document).on('mouseenter', '.facets__list, .facets__price', function (e) {
    e.stopPropagation();
  });
});
